import { Grid } from '@mui/material';
import {
  IniciadoAutorizadoAnualBarraApilada,
  IniciadoAutorizadoMensualBarraApilada,
  IniciadoAutorizadoMensualDona,
  IniciadoPorCategoriaMensualDona,
} from '../components';

export const IniciadoAutorizadoSection = () => {
  return (
    <>
      <Grid item container spacing={2} xs={12} md={6}>
        <Grid item xs={12}>
          <IniciadoAutorizadoMensualBarraApilada />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12} md={6}>
        <Grid item xs={12}>
          <IniciadoAutorizadoAnualBarraApilada />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12} md={6}>
        <Grid item xs={12}>
          <IniciadoAutorizadoMensualDona />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12} md={6}>
        <Grid item xs={12}>
          <IniciadoPorCategoriaMensualDona />
        </Grid>
      </Grid>
    </>
  );
};
